import clsx from 'clsx';
import styles from './course.module.scss';
import BreadCrumb from '~/components/Breadcrumb';
import { Link, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { getProblemById } from '~/api/problems';
import { getSubjectNameByClassID } from '~/api/courses';
import { getAllSubmissions } from '~/api/submissions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSlack } from '@fortawesome/free-brands-svg-icons';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import CourseViewDetailComponent from '~/components/CourseViewDetail';
import { reFormatedTime } from '~/utils';

const MainChild = () => {
    const { id, problem_id, topic_problems_id } = useParams();

    const [problem, setProblem] = useState({
        id: 0,
        title: '',
        level_id: 0,
        level_name: '',
        description: '',
    });
    const [subjectName, setSubjectName] = useState('');
    const [allSubmissions, setAllSubmissions] = useState([]);

    const [textOfSearch, setTextOfSearch] = useState('');

    const handleChangeSearchInput = (event) => {
        setTextOfSearch(event.target.value);
    };

    const handleSubmitSearch = () => { };

    useEffect(() => {
        const fetchRelevantName = async (id, problem_id, topic_problems_id) => {
            const res = await getProblemById(problem_id);
            setProblem(res.body);

            const fetchSubjectName = await getSubjectNameByClassID(id);
            setSubjectName(fetchSubjectName.body.subject_name);

            const fetchAllSubmissions = await getAllSubmissions(topic_problems_id);
            setAllSubmissions(fetchAllSubmissions.body);
            console.log(fetchAllSubmissions.body);
        };

        fetchRelevantName(id, problem_id, topic_problems_id);
    }, [id, problem_id, topic_problems_id]);

    return (
        <div className={clsx(styles.overviewSubmissions)}>
            <div className={clsx(styles.sortBar)}>
                <div className={clsx(styles.sortBarSearch)}>
                    <div className={clsx(styles.sortBarSearchIcon)}>
                        <FontAwesomeIcon icon={faMagnifyingGlass} />
                    </div>
                    <div className={clsx(styles.sortBarSearchInput)}>
                        <input
                            type="text"
                            value={textOfSearch}
                            placeholder="Search by course name..."
                            className={clsx('form-control', styles.sortBarFormControl)}
                            onChange={handleChangeSearchInput}
                            onKeyUp={handleSubmitSearch}
                        />
                    </div>
                </div>
                <Link
                    to={`/courses/${id}/topic_problems/${topic_problems_id}/problems/${problem_id}/group_submissions`}
                >
                    <div className={clsx(styles.groupSubmissions)}>

                        <a>Group Submissions</a>
                    </div>
                </Link>
            </div>
            <div className={clsx(styles.submissionsField)}>
                <div className={clsx(styles.submissionsHeader)}>
                    <div className={clsx('col-1')}>No.</div>
                    <div className={clsx('col-4')}>Full Name</div>
                    <div className={clsx('col-1')}>Status</div>
                    <div className={clsx('col-2', 'text-center')}>Score / 10.00</div>
                    {/* <div className={clsx('col-1', 'text-center')}>Time...</div> */}
                    <div className={clsx('col-2')}>Start time</div>
                    <div className={clsx('col-2')}>End time</div>
                </div>
                <div className={clsx(styles.submissionsBody)}>
                    <div className={clsx(styles.submissionsBody)}>
                        {allSubmissions.map((submission, indexOfSubmission) => {
                            return (
                                <div className={clsx(styles.submissionsRow)}>
                                    {/* <div className={clsx('col-1')}>{submission.user_id}</div> */}
                                    <div className={clsx('col-1')}>{indexOfSubmission + 1}</div>
                                    <div className={clsx('col-4')}>{submission.name}</div>
                                    <div className={clsx('col-1')}>{submission.status}</div>
                                    <div className={clsx('col-2', 'text-center')}>{submission.score.toFixed(2)}</div>
                                    {/* <div className={clsx('col-1', 'text-center')}>Time...</div> */}
                                    <div className={clsx('col-2')}>{reFormatedTime(submission.start_time)}</div>
                                    <div className={clsx('col-2')}>{reFormatedTime(submission.end_time)}</div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
};

const OverviewSubmissions = () => {
    return <CourseViewDetailComponent state="results" mainChild={<MainChild />} />;
};

export default OverviewSubmissions;
